import { render, staticRenderFns } from "./PositivelyImpactWellbeing.vue?vue&type=template&id=1392d11f&"
import script from "./PositivelyImpactWellbeing.vue?vue&type=script&lang=js&"
export * from "./PositivelyImpactWellbeing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports